<template>
  <div>
    <!-- 缴费 -->
    <div class="inner-page-content">
      <public-title
        v-if="currentSignup.id > 0 && currentSignup.status == '已完成'"
        title="报名成功，缴费信息"
      >
        <span class="sub">Payment information</span>
      </public-title>
      <!-- 审核中用户 -->
      <div
        class="section"
        v-if="currentSignup.id > 0 && currentSignup.status != '已完成'"
      >
        <div class="s-left">
          <p class="info">
            <span>会议报名状态为:</span> {{ currentSignup.status
            }}{{ currentSignup.status === "审核中" ? "，请完成转账后查询审核结果" : ""
            }}{{ currentSignup.status === "未通过" ? "，未通过报名申请，无法缴费" : "" }}
          </p>
        </div>
      </div>

      <!-- 审核通过 未缴费 且身份为需缴费的用户 -->
      <div
        class="section"
        v-else-if="
          currentSignup.id > 0 &&
          currentSignup.status == '已完成' &&
          currentSignup.paid_status != '已缴费' &&
          currentSignup.paid_status != '申请退费' &&
          ['A1', 'A2', 'A3', 'A4', 'A5'].includes(currentSignup.attendid.code) > 0
        "
      >
        <div class="s-left">
          <p class="info"><span>缴费状态: </span>未缴费</p>
          <p class="info"><span>原价: </span> ¥{{ currentSignup.conference.price }}</p>
          <p class="info"><span>缴费金额: </span> ¥{{ payPrize }}</p>
        </div>
        <div class="s-right">
          <el-button v-if="canpay" class="handle-btn" type="primary" @click="handlePayment"
            >立即缴费</el-button
          >
          <el-button v-else class="handle-btn" type="primary"
            >缴费已停止</el-button
          >
        </div>
      </div>

      <!-- 审核通过 未缴费 且身份为不需缴费的用户(免费或者其他用户) -->
      <div
        class="section"
        v-else-if="
          currentSignup.id > 0 &&
          currentSignup.status == '已完成' &&
          ['A7', 'A6'].includes(currentSignup.attendid.code)
        "
      >
        <div class="s-left">
          <p class="info"><span>报名身份: </span> {{ currentSignup.attendid.name }}</p>
          <p class="info"><span>缴费金额: </span> ¥0</p>
        </div>
        <div class="s-right">
          <el-button class="handle-btn" type="primary" disabled>无需缴费</el-button>
        </div>
      </div>

      <!-- 审核通过 已缴费 paid_order为有订单的状态，在退费中就没有了-->
      <div
        class="section"
        v-else-if="
          currentSignup.id > 0 &&
          currentSignup.paid_order &&
          (currentSignup.paid_status == '已缴费' ||
            currentSignup.paid_status == '申请退费')
        "
      >
        <div class="s-left">
          <p class="info"><span>缴费状态：</span>{{ currentSignup.paid_status }}</p>
          <p class="info"><span>缴费金额: </span> ¥{{ payPrize }}</p>
          <p class="info"><span>缴费时间: </span> {{ payDate }}</p>
        </div>
        <div class="s-right">
          <el-button
            v-if="
              canrefund &&
              currentSignup.signinstatus !== '已签到' &&
              currentSignup.paid_status !== '退费中' &&
              currentSignup.paid_status !== '申请退费'
            "
            class="handle-btn"
            type="primary"
            @click="handleRefund"
            >申请退费</el-button
          >
        </div>
      </div>
    </div>

    <!-- 发票 -->
    <!--未缴费不显示开票状态-->
    <div
      class="inner-page-content"
      v-if="
        currentSignup.id > 0 &&
        currentSignup.paid_order &&
        currentSignup.paid_status == '已缴费'
      "
    >
      <public-title title="发票信息">
        <span class="sub">Invoice information</span>
      </public-title>
      <div class="section">
        <div class="s-left">
          <p class="info">
            <span>发票状态：</span> {{ isInvoiced ? "已开票" : "未开票" }}
          </p>
        </div>
        <div class="s-right">
          <el-button
            v-if="caninvoice && !isInvoiced"
            class="handle-btn"
            type="primary"
            :loading="loading"
            @click="applyInvoice"
            >申请发票</el-button
          >
          <!-- <el-button
            v-else-if="!isInvoiced && currentSignup.signinstatus == '未签到'"
            class="handle-btn"
            style="background-color: grey"
            disabled
            >尚未签到</el-button
          > -->
          <el-button v-if="isInvoiced" :loading="redflushload" class="handle-btn" type="primary" @click="redflushInvoice"
            >退票</el-button
          >
          <el-button v-if="isInvoiced" :loading="viewload" class="handle-btn" type="primary" @click="viewInvoice"
            >预览发票</el-button
          >
          <el-button v-if="isInvoiced" :loading="pdfdownloadload" class="handle-btn" type="primary" @click="downLoadInvoicePdf"
            >下载发票PDF</el-button
          >
          <el-button v-if="isInvoiced" :loading="ofddownloadload" class="handle-btn" type="primary" @click="downLoadInvoiceOfd"
            >下载发票OFD</el-button
          >
          <el-button v-if="isInvoiced" :loading="xmldownloadload" class="handle-btn" type="primary" @click="downLoadInvoiceXml"
            >下载发票XML</el-button
          >
          <el-button v-if="!caninvoice && !isInvoiced" type="text" size="small">线上开票功能已关闭，请联系财务部010-58934281</el-button>
        </div>
      </div>
    </div>
    <sign-dialog
      v-model="dialogShow"
      :dialogConfig="dialogConfig"
      @closeDialog="closeDialog"
    >
      <component
        :is="currentView"
        :dialogConfig="dialogConfig"
        @handleClickSure="handleClickSure"
        @handleClickPaid="handleFinishPay"
        @handleClickNewPay="goWechatPayment"
      />
    </sign-dialog>
    <vulueDialog
      :valueDialogShow="valueDialogShow"
      :valueShow="valueShow"
      @closeDialogs="closeDialogs"
      @closeDialog1="closeDialog1"
    />
  </div>
</template>

<script>
import PublicTitle from "@components/title";
import signDialog from "@/components/dialog";
import redflushDialog from "@/components/dialog";
import { Invoice } from "@/store/entity/invoice";
import { UserOrderRecord } from "@/store/entity/pay";
import { Confsite } from "@/store/entity/confsite";
import CurrentUserMixin from "@/mixin/CurrentUser";
import vulueDialog from "../../components/dialog/valueData.vue";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from "axios";
export default {
  name: "informations",
  components: {
    PublicTitle,
    vulueDialog,
    signDialog,
    examineFail: () => import("./examineFail.vue"),
    existPay: () => import("./existPay.vue"),
    payFail: () => import("./payFail.vue"),
    redflushSuccess: () => import("./redflushSuccess.vue"),
    redflushFail: () => import("./redflushFail.vue"),
  },
  mixins: [CurrentUserMixin],
  data() {
    return {
      redflushload:false,
      pdfdownloadload:false,
      ofddownloadload:false,
      xmldownloadload:false,
      viewload:false,
      valueDialogShow: false,
      valueShow: "请您在会议现场完成签到后申请开票!",
      loading: false,
      isInvoiced: false,
      invoiceid: "",
      currentCoference: {},
      headerConfig: {
        headerIcon: "city ct-xiangyou",
        headerTitle: "缴费管理",
      },
      currentView: null,
      dialogShow: false,
      dialogConfig: {
        title: "",
        width: "80%",
      },
      payPrize: 0.0, // 要支付的金额
      payDate: null, // 支付日期
      existPayRecords: [], // 支付过的
    };
  },

  async created() {
    this.isInvoice(this.currentSignup.id);
    this.setStatusFromSignupInfo(this.currentSignup);
  },
  computed: {
      //是否显示【申请退费】
    canrefund(){
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.conferencedate).getTime()
      if(this.currentSignup.conference.conferencedate!=null && d1>=d2){
        return false;
      }else{
        return true;
      }
    },
    canpay(){
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.paydeadline).getTime()
      if(this.currentSignup.conference.paydeadline!=null && d1>=d2){
        return false;
      }else{
        return true;
      }
    },
    caninvoice(){
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.invoicedeadline).getTime()
      if(this.currentSignup.conference.invoicedeadline!=null && d1>=d2){
        return false;
      }else{
        return true;
      }
    }
  },
  watch: {
    currentSignup: {
      handler(currentSignup) {
        this.setStatusFromSignupInfo(currentSignup);
        this.isInvoice(currentSignup.id);
      },
      deep: true,
    },
  },

  methods: {
    setStatusFromSignupInfo(currentSignup) {
      // 根据报名信息设置页面状态
      if (currentSignup.id == undefined || currentSignup.id == null) {
        // 如果没找到注册信息currentSignup是{}
        this.dialogShow = false;
        this.currentView = "examineFail";
        this.dialogConfig.title = "抱歉,未找到报名信息";
      } else if (currentSignup.id > 0) {
        if (
          currentSignup.status == "已完成" &&
          ["A6", "A7"].includes(currentSignup.attendid.code)
        ) {
          // 无需缴费的用户
          this.dialogShow = false;
          this.currentView = null;
        } else if (
          currentSignup.status == "已完成" &&
          ["A1", "A2", "A3", "A4", "A5"].includes(currentSignup.attendid.code) &&
          currentSignup.paid_order_id &&
          currentSignup.paid_status == "已缴费"
        ) {
          // 需缴费且缴费完成的用户
          this.getPaidInfo();
          this.dialogShow = false;
          this.dialogConfig.title = "";
          this.currentView = null;
        } else {
          this.getPayPrize();
          this.dialogShow = false;
          this.dialogConfig.title = "抱歉,未缴费";
          this.currentView = null;
        }
      } else {
        this.dialogShow = false;
        this.currentView = null;
      }
    },
    async fetchData() {  
      try {  
  
        // 使用Promise的setTimeout模拟异步操作  
        const response = await new Promise((resolve) => {  
          setTimeout(() => {  
            resolve('模拟数据'); // 假设这是后台返回的数据  
          }, 5000); // 5000毫秒即5秒  
        });  
  
      } catch (e) {  
      } finally {  
      }  
    }, 
    async redflushInvoice(){
      try{
        this.redflushload = true;
        let res = await Invoice.redflushInvoice(this.currentSignup.paid_order_id);
        //let res = await this.fetchData();
        this.dialogShow = true;
        if(res.code=="S0000"){
          this.currentView = "redflushSuccess";
          this.dialogConfig.title = "红冲成功";
          this.isInvoice(this.currentSignup.id)
        }else{
          this.currentView = "redflushFail";
          this.dialogConfig.title = "红冲失败！"+res.msg;
        }
        
      }catch(e){
        
      }finally{
        this.redflushload = false;

      }
    },
    async downLoadInvoicePdf() {
      this.pdfdownloadload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.pdfdownloadload = false;
      if(data.code==='S0000'){
          const link = document.createElement("a");
          link.href = data.msg.pdfUrl;
          link.click();
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async downLoadInvoiceOfd() {
      this.ofddownloadload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.ofddownloadload = false;
      if(data.code==='S0000'){
          const link = document.createElement("a");
          link.href = data.msg.ofdUrl;
          link.click();
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async downLoadInvoiceXml() {
      this.xmldownloadload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.xmldownloadload = false;
      if(data.code==='S0000'){
          const link = document.createElement("a");
          link.href = data.msg.xmlUrl;
          link.click();
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async viewInvoice() {
      this.viewload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.viewload = false;
      if(data.code==='S0000'){
          // const link = document.createElement("a");
          // link.href = data.msg;
          // link.click();
          window.open(data.msg.h5Url,"_blank")
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async getPayPrize() {
      const prize = await UserOrderRecord.getPrizeBySignupId(this.currentSignup.id);
      this.payPrize = prize;
    },
    async getPaidInfo() {
      const res = await UserOrderRecord.fetch({
        uuid: this.currentSignup.paid_order_id,
        per_page: 1,
      });
      if (res.total > 0) {
        const paid_order = res.results[0];
        this.payPrize = paid_order.paid_prize;
        this.payDate = this.$moment(paid_order.finish_paid_time).format(
          "YYYY年MM月DD日 HH时mm分ss秒"
        );
      } else {
        this.payPrize = null;
        this.payDate = null;
      }
    },

    async isInvoice(signup_id) {
      if (signup_id == undefined || signup_id == null) {
        // 如果没找到注册信息currentSignup是{}
        this.dialogShow = true;
        this.currentView = "examineFail";
        this.dialogConfig.title = "抱歉,未找到报名信息";
      } else if (signup_id > 0) {
        let data = await Invoice.isInvoiced(signup_id);
        if (data.isinvoiced == true) {
          this.isInvoiced = true;
          this.invoiceid = data.invoice.id;
        } else {
          this.isInvoiced = false;
        }
      }
    },
    handleClickIocn() {
      history.go(-1);
    },

    /* 申请退费 */
    handleRefund() {
      this.$router.push("/refund");
    },

    /* 申请发票 */
    applyInvoice() {
      const UNSIGN_MAKEOUT_INVOICE_DEADLINE = 2
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.conferencedate).getTime()
      if(d1-d2<=(UNSIGN_MAKEOUT_INVOICE_DEADLINE)*24*3600*1000 && this.currentSignup.signinstatus=="未签到"){
        this.valueDialogShow = true;
      }else{
        this.$router.push("/invoice");
      }
    },

    closeDialogs(val) {
      this.valueDialogShow = val;
      // this.loading = val;
    },
    closeDialog1(){
      this.valueDialogShow = false
    },
    /* 立即缴费 */
    async handlePayment() {
      //先校验报名时选的会场是否已满
      await Confsite.isfulled(this.currentSignup.id);
      // 先检测是不是已经支付过，只检查最近支付的一条
      const res = await UserOrderRecord.fetch({
        signup_id: this.currentSignup.id,
        per_page: 5,
        buyer_id: this.currentUser.id,
        order_by_desc: "create_time",
        status: "unpay",
      });
      await this.$store.dispatch("user/resetFetchSignupInfo");
      this.existPayRecords = res.results.filter((x) => x.refund_status != "已退费");
      if (this.existPayRecords.length == 0) {
        // 没有支付记录，直接去支付
        this.goWechatPayment();
      } else {
        this.dialogShow = true;
        this.dialogConfig.title = "提示：";
        this.currentView = "existPay";
      }
    },
    goWechatPayment() {
      // 跳转到扫码支付页
      this.$router.push({
        name: "WechatpayPage",
        query: { signupId: this.currentSignup.id },
      });
    },

    async handleFinishPay() {
      // 给后台发请求调查单接口是否已支付完成
      // 有可能用户支付完成了，但忘记点完成付款按钮
      const actions = async (orders) => {
        for (const order of orders) {
          await UserOrderRecord.finisheOrder({ trade_no: order.trade_no });
        }
      };
      await actions(this.existPayRecords);
    },

    closeDialog(done) {
      done();
    },

    handleClickSure() {
      this.dialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.inner-page-content {
  margin: 60px 0;
}
.section {
  @include flex-between;
  width: 1200px;
  margin: 30px auto 0;
  padding: 15px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  .info {
    font-size: 14px;
    line-height: 30px;
    color: #666;

    span {
      color: $defaultColor;
    }
  }
}
::v-deep .el-dialog {
  background: var(--main-color);
  background-color: red;
  border-radius: 5px;
  .el-dialog__title,
  .el-dialog__close {
    color: #fff;
  }
}
</style>
